import {searchReportHTML, searchReport, searchReportById} from '../reports/reports.api';

// #region Globals
const CONTEXT_BASE_PATH = 'caminossantiago/pdf';
const CONTEXT_BASE_HTML_PATH = 'caminossantiago/html';
const CONTEXT_SINGLE_BASE_PATH = 'caminossantiago/pdfindividual';
// #endregion

// #region Public functions
async function getWayStJamesPdf(id) {
  return searchReportById(id, CONTEXT_SINGLE_BASE_PATH);
}
async function searchWayStJamesPdf(searchParams = {}) {
  return searchReport(searchParams, CONTEXT_BASE_PATH);
}
async function searchWayStJamesHtml(searchParams = {}) {
  return searchReportHTML(searchParams, CONTEXT_BASE_HTML_PATH);
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  getWayStJamesPdf,
  searchWayStJamesPdf,
  searchWayStJamesHtml,
};
